import { TableRow } from '@shared/UI';
import { ISettingsAccountsDto } from '@shared/api';

interface Options {
    onAccountViewClick: (account: ISettingsAccountsDto) => void;
}

export function getAccountsTableRows(options: Options): TableRow<ISettingsAccountsDto> {
    const { onAccountViewClick } = options;
    return { onClick: (row) => () => onAccountViewClick(row) };
}
